import * as Sentry from '@sentry/react';
import React from 'react';
import { Provider } from 'react-redux';
import { App } from './app';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { getConfig, initSentry } from './config';
import { store } from './utils/store';
import { onRedirectCallback } from 'utils';

import './index.css';
import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';

initSentry(Sentry);
const config = getConfig();

const providerConfig: Auth0ProviderOptions = {
  domain: config.domain,
  clientId: config.clientId,
  cacheLocation: 'localstorage',
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: window.location.origin,
    ...(config.audience ? { audience: config.audience } : null),
  },
};

const root = createRoot(document.getElementById('root'));

root.render(
  <Auth0Provider {...providerConfig}>
    <Provider store={store.instance}>
      <Router>
        <App />
      </Router>
    </Provider>
  </Auth0Provider>,
);
